import * as token from "@universityofmaryland/web-token-library";
import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import "@universityofmaryland/web-styles-library/element";
import "@universityofmaryland/web-styles-library/layout";
import "@universityofmaryland/web-styles-library/animation";
import "@universityofmaryland/web-styles-library/typography";
import "@universityofmaryland/web-utilities-library/media";
import "@universityofmaryland/web-utilities-library/dom";
import "@universityofmaryland/web-icons-library/controls";
import "@universityofmaryland/web-icons-library/communication";
import "@universityofmaryland/web-icons-library/files";
import "@universityofmaryland/web-icons-library/brand";
import "@universityofmaryland/web-icons-library/arrows";
import { createAnimationIndicator } from "../../../atomic/animations/actions/indicator.js";
import "@universityofmaryland/web-utilities-library/styles";
import "../../../atomic/animations/brand/card-stack.js";
import "@universityofmaryland/web-styles-library";
import "@universityofmaryland/web-utilities-library/accessibility";
import "@universityofmaryland/web-utilities-library/performance";
import "@universityofmaryland/web-icons-library/location";
import "@universityofmaryland/web-icons-library/calendar";
import "@universityofmaryland/web-utilities-library/theme";
import "../../../atomic/layout/block/stacked.js";
import "../../../atomic/layout/person/columns.js";
import "@universityofmaryland/web-icons-library/social";
import "@universityofmaryland/web-utilities-library/string";
import "@universityofmaryland/web-utilities-library/animation";
import "../../../atomic/text-lockup/small.js";
const createCarouselIndicatorWrapper = ({
  count,
  isThemeDark,
  isBackground = true,
  callback
}) => {
  const overlayColor = isBackground && !isThemeDark ? token.color.gray.lightest : void 0;
  const indicator = createAnimationIndicator({
    count,
    isThemeDark,
    callback: callback || (() => {
    }),
    ...overlayColor && { overlayColor }
  });
  const model = new ElementBuilder().withClassName("carousel-indicator-wrapper").withStyles({
    element: {
      display: "flex",
      justifyContent: "center",
      width: "100%",
      padding: `0 ${token.spacing.md}`,
      ...isBackground && {
        backgroundColor: token.color.gray.lightest,
        ...isThemeDark && { backgroundColor: token.color.black }
      },
      [`@media (${token.media.queries.tablet.min})`]: {
        padding: `0 ${token.spacing.lg}`
      }
    }
  }).withChild(indicator).build();
  return {
    element: model.element,
    styles: model.styles,
    position: indicator.position
  };
};
export {
  createCarouselIndicatorWrapper
};
//# sourceMappingURL=indicator-wrapper.js.map
